/**
 * @file 常量定义，定义所有ajax接口的path
 * @author lizhaoxia<lizhaoxia@baijiahulian.com>
 * @date 2019-07-08
 */

const ajaxConfig = {
    USER: {
        GET_USER_INFO: '/api/getuserinfo'
    },
    RESET: {
        SEND_SMS_CODE: '/cas/password/reset/sendSmsCode',
        RESET_PASSWORD: '/cas/password/reset/submit',
    },
    LOGIN: {
        GET_CAPTCHA: 'https://captcha.genshuixue.com/dogfood/generate',
        SEND_SMS_CODE: '/cas/phone/sendSmsCode',
        POST_LOGIN: '/cas/bg/login',
        POST_LOGIN_ACCOUNT_PASSWORD: '/cas/bg/login',
        POST_LOGIN_PHONE_CODE: '/cas/bg/login',
        POST_LOGIN_QR_CODE: '/cas/bg/login',
        POST_LOGOUT: '/cas/bg/logout',
    },
    QR_CODE: {
        REFRESH_ID: '/cas/dispatcher/qrcode/refresh',
        GET_IMG: '/cas/dispatcher/qrcode/qrImg',
        GET_STATE: '/cas/dispatcher/qrcode/qrConnect',
        CONFIRM: '/cas/dispatcher/qrcode/confirm',
        SUBMIT: '/cas/dispatcher/qrcode/submit',
        CANCEL: '/cas/dispatcher/qrcode/cancel'
    }
};

/**
 * HTTP状态码
 */
export const HttpCode = {
    // 请求成功
    ok: 200,
    // 操作成功
    success: 200,
    // 操作失败
    error: 1,
    // 无权限
    noAuth: 400,
    // 参数异常
    paramsError: 411,
    // 业务错误
    businessError: 451,
    // 请登录
    needLogin: 700,
    // 资源不存在
    notFound: 404,
    // 服务端错误,
    serverError: 500,
};

export default ajaxConfig;
